var _foreignObject, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("switch", null, _foreignObject || (_foreignObject = /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45 45h260v260H45z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 73h204v204H73z",
    style: {
      fill: "#673081"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 114.75h260v119H45z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32 121.25h286v106H32z",
    style: {
      fill: "#fff"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 128h272v92.5H39z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m131.429 133.75-65.894 81h63.009l65.893-81zm141.368 0-65.894 81h12.79l65.894-81zm-54.061 0-65.894 81h29.763l65.893-81z",
    style: {
      fill: "#fff"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.389 105.339c-5.266 0-9.55 4.284-9.55 9.55s4.284 9.55 9.55 9.55 9.55-4.284 9.55-9.55-4.284-9.55-9.55-9.55"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 73.389,
    cy: 114.889,
    r: 5,
    style: {
      fill: "#fff"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M175.194 105.339c-5.266 0-9.55 4.284-9.55 9.55s4.284 9.55 9.55 9.55 9.55-4.284 9.55-9.55-4.284-9.55-9.55-9.55"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 175.194,
    cy: 114.889,
    r: 5,
    style: {
      fill: "#fff"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M277 105.339c-5.266 0-9.55 4.284-9.55 9.55s4.284 9.55 9.55 9.55 9.55-4.284 9.55-9.55-4.284-9.55-9.55-9.55"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 277,
    cy: 114.889,
    r: 5,
    style: {
      fill: "#fff"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.389 223.45c-5.266 0-9.55 4.284-9.55 9.55s4.284 9.55 9.55 9.55 9.55-4.284 9.55-9.55-4.284-9.55-9.55-9.55"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 73.389,
    cy: 233,
    r: 5,
    style: {
      fill: "#fff"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175.194 223.45c-5.266 0-9.55 4.284-9.55 9.55s4.284 9.55 9.55 9.55 9.55-4.284 9.55-9.55-4.284-9.55-9.55-9.55"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 175.194,
    cy: 233,
    r: 5,
    style: {
      fill: "#fff"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M277 223.45c-5.266 0-9.55 4.284-9.55 9.55s4.284 9.55 9.55 9.55 9.55-4.284 9.55-9.55-4.284-9.55-9.55-9.55"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 277,
    cy: 233,
    r: 5,
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMira);
export default __webpack_public_path__ + "static/media/mira.1b01e8c1a2c2812a980c822b1aea7494.svg";
export { ForwardRef as ReactComponent };